import { configureStore } from "@reduxjs/toolkit";
import { rootReducer } from "./RootReducer";
import { RootStateType } from "./RootReducer";

export const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== "production"
});

export type RootState = RootStateType;
export type AppDispatch = typeof store.dispatch;
